import type { OrganizationDto } from '@/types/dtos/organizations/organization.dto.ts';
import { useQuery } from '@tanstack/react-query';
import { METHOD, sendJSONRequest } from '@/state/http-request.helpers.ts';
import { useAuth } from '@clerk/clerk-react';

export const GET_ORGANIZATION_QUERY_KEY = 'get-organization';

export const useGetOrganizationQuery = (id?: string) => {
  const { getToken } = useAuth();

  return useQuery({
    queryKey: [GET_ORGANIZATION_QUERY_KEY, id],
    queryFn: async () => {
      const token = await getToken();
      return getOrganization(id!, token ?? '');
    },
    enabled: !!id,
    // getting current organization data (to update local storage) can happen at most every 2 seconds
    staleTime: 2000,
  });
};

export const getOrganization = async (id: string, token: string): Promise<OrganizationDto> => {
  const url = `${import.meta.env.VITE_API_URL}/organizations/${id}`;
  return sendJSONRequest({ url, method: METHOD.GET, token });
};
